import { Row, Spin } from "antd";
import { useGetBucketFacets } from "../lib/hooks/useGetBucketFacets";
import SelectFilter from "@shared/ui/filters/SelectFilter";

const BucketCategoryFilter = ({
  selectedCategory,
  setSelectedCategory,
  onConfirm,
  onClose,
}: {
  selectedCategory: string[];
  setSelectedCategory: (val: string[]) => void;
  onConfirm: () => void;
  onClose: () => void;
}) => {
  const { isFetching, facets } = useGetBucketFacets();
  const itemsToDisplay = facets?.category?.map((role) => role._id) || [];
  return (
    <>
      {isFetching ? (
        <Row
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin style={{ width: 30, height: 30 }} />
        </Row>
      ) : (
        <SelectFilter
          placeholder="Select category"
          initialTagCount={3}
          itemsToDisplay={itemsToDisplay}
          selectedItems={selectedCategory}
          handleSelectionChange={(items: string[]) =>
            setSelectedCategory(items)
          }
          props={{ confirm: onConfirm, close: onClose }}
        />
      )}
    </>
  );
};

export default BucketCategoryFilter;
